
<div class="login-line">
  <div class="modal login-line-modal">
    <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    <div class="modal-background" @click="closeModal"></div>
    <div class="modal-card">
      <section class="modal-card-body">
        <div>
          <div>
            <!-- Step 1 -->
            <p class="title is-size-5 has-text-success has-text-left">{{ $t("login.step-1") }}</p>
            <div v-if="$store.getters.firstCode">
              <a
                id="friend-button"
                class="button is-success is-medium is-rounded"
                v-clipboard:copy="$store.getters.firstCode"
                v-clipboard:success="onCopyGoToLine"
                @click="goToLine"
              >
                <i class="fab fa-line fa-2x" />&nbsp;
                <i class="fa fa-plus" />&nbsp;
                <img src="../assets/logo-round-96.png" width="35" />
              </a>
            </div>

            <div v-if="!$store.getters.firstCode">
              <a class="button is-success is-medium is-rounded has-text-weight-semibold">
                <i class="fas fa-spinner fa-spin"></i>
              </a>
            </div>

            <hr />
            <!-- Step 2 -->
            <p class="title is-size-5 has-text-success has-text-left">{{ $t("login.step-2") }}</p>
            <div v-if="$store.getters.firstCode">
              <a
                id="first-code-btn"
                class="button is-medium is-outlined is-link has-text-link has-text-weight-semibold is-rounded"
                v-clipboard:copy="$store.getters.firstCode"
                v-clipboard:success="onCopy"
                v-if="blurButton"
              >{{$store.getters.firstCode}}</a>
            </div>
            <div v-if="!$store.getters.firstCode">
              <a
                class="button is-medium is-outlined is-link has-text-link has-text-weight-semibold is-rounded"
              >
                <i class="fas fa-spinner fa-spin"></i>
              </a>
            </div>
            <!-- Step 3 -->
            <hr />
            <p class="title is-size-5 has-text-success has-text-left">{{ $t("login.step-3") }}</p>
            <div>
              <div class="field">
                <div
                  class="control has-icons-left has-icons-right"
                  style="width: calc(0.35 * var(--page-w, 100vw)); margin: 0 auto"
                >
                  <input
                    v-model="inputCode"
                    class="input is-link is-medium has-text-centered is-expanded has-text-weight-semibold"
                    type="number"
                    placeholder="00"
                    v-on:keyup="checkCode"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-key"></i>
                  </span>
                </div>
              </div>
              <progress class="progress is-danger" :value="timer" :max="maxTime" />
            </div>
          </div>
        </div>

        <br />
        <p class="has-text-danger" style="line-height:0.1em" v-if="error">{{ error }}</p>
      </section>
    </div>
  </div>
</div>
